import React from "react";
import HeroBanner from "./HeroBanner/HeroBanner";
import BannerBoxesGuest from "./BannerBoxesGuest/BannerBoxesGuest";
import WhoWeAre from "./WhoWeAre/WhoWeAre";
import Sponsors from "./Sponsors/Sponsors";
import HomeContact from "./HomeContact/HomeContact";

const GuestsHome = () => {
  return (
    <main style={{ maxWidth: "1500px", margin: "0 auto" }}>
      <HeroBanner />
      <BannerBoxesGuest />
      <WhoWeAre />
      <Sponsors />
      <HomeContact />
    </main>
  );
};

export default GuestsHome;
